import React, { Component } from "react";
import { MasterPage } from "..";

import { Alerta, Combo, TipoAlerta } from "@intechprev/componentes-web";

import { PlanoService } from "../../services";

import { PlanoVinculadoEntidade } from "../../entidades";
import { Assistido } from "./Assistido";
import { Ativo } from "./Ativo";
import { DMN_CATEGORIA } from "../../domains";

interface Props { }

interface State {
  planos: Array<PlanoVinculadoEntidade>;
  plano: PlanoVinculadoEntidade;
  cdPlano: string;
  processosBeneficio: any;
  processo: any;
  especieAnoNumProcesso: string;
}

export class Home extends Component<Props, State> {
  public homeAssistido = React.createRef<Assistido>();
  public homeAtivo = React.createRef<Ativo>();

  state = {
    planos: [new PlanoVinculadoEntidade()],
    plano: new PlanoVinculadoEntidade(),
    cdPlano: "",
    processosBeneficio: {},
    processo: {},
    especieAnoNumProcesso: ""
  };

  componentDidMount = async () => {
    //await this.page.current.alternarLoading();

    var planos = await PlanoService.Buscar();

    var plano = planos[0];

    var cdPlano = plano.CD_PLANO;

    await this.setState({
      planos,
      plano,
      cdPlano,
    });

    //await this.page.current.alternarLoading();
  };

  carregarPlano = async () => {
    //await this.page.current.alternarLoading();

    var plano = null;
    var cdPlano = "";

    if (this.state.cdPlano)
      plano = this.state.planos.filter((plano: any) => plano.CD_PLANO === this.state.cdPlano)[0];
    else plano = this.state.planos[0];

    cdPlano = plano.CD_PLANO;

    await this.setState({
      plano,
      cdPlano,
    });

    if (this.homeAtivo.current)
      await this.homeAtivo.current.carregarPlano();
    else if (this.homeAssistido.current)
      await this.homeAssistido.current.carregarPlano();

    //await this.page.current.alternarLoading();
  };

  condicaoAtivo = () => {
    const categoriasAtivo = [DMN_CATEGORIA.ATIVO, DMN_CATEGORIA.AUTOPATROCINIO, DMN_CATEGORIA.DIFERIDO]
    return (
      // this.state.plano.CD_PLANO === DMN_PLANO.PREVIDENCIAL_B &&
      categoriasAtivo.some(x => x === this.state.plano.CD_CATEGORIA)
    );
  };

  renderSelecionarPlano = () => {
    if (this.state.planos.length > 1) {
      return (
        <Combo
          contexto={this}
          titulo={"Selecione um plano"}
          onChange={this.carregarPlano}
          nome={"cdPlano"}
          valor={this.state.cdPlano}
          opcoes={this.state.planos}
          nomeMembro={"DS_PLANO"}
          valorMembro={"CD_PLANO"}
          obrigatorio
          padrao={this.state.cdPlano}
        />
      );
    }
    return null;
  };

  renderTipoHome = () => {
    if (this.condicaoAtivo()) {
      return (
        <Ativo
          ref={this.homeAtivo}
          plano={this.state.plano}
          renderSelecionarPlano={this.renderSelecionarPlano}
          {...this.props}
        />
      );
    }

    if (this.state.planos[0].CD_CATEGORIA === DMN_CATEGORIA.ASSISTIDO) {
      return (
        <Assistido
          ref={this.homeAssistido}
          plano={this.state.plano}
          renderSelecionarPlano={this.renderSelecionarPlano}
          {...this.props}
        />
      );
    }

    return (
      <MasterPage {...this.props}>
        {this.renderSelecionarPlano()}
        <Alerta
          tipo={TipoAlerta.info}
          mensagem={"Nenhuma informação disponível para este plano."}
        />
      </MasterPage>
    );
  };

  render() {
    return this.renderTipoHome();
  }
}
